// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningResponse {
    'customerID'?: string;
    'fpl'?: string;
    'fplEligibility'?: string;
    'fplLimit'?: string;
    'householdEstimatedIncome'?: string;
    'householdEstimatedSize'?: string;
    'incomeEligibility'?: string;
    'incomeLimit'?: string;
    'transactionCorrelationId'?: number;
    'transactionDateTime'?: Moment;
    'transactionId'?: string;
    'transactionMessage'?: string;
    'transactionStatus'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningResponse>> = [
        {
            "name":     "customerID",
            "baseName": "customerID",
            "type":     "string"
        },
        {
            "name":     "fpl",
            "baseName": "fpl",
            "type":     "string"
        },
        {
            "name":     "fplEligibility",
            "baseName": "fplEligibility",
            "type":     "string"
        },
        {
            "name":     "fplLimit",
            "baseName": "fplLimit",
            "type":     "string"
        },
        {
            "name":     "householdEstimatedIncome",
            "baseName": "householdEstimatedIncome",
            "type":     "string"
        },
        {
            "name":     "householdEstimatedSize",
            "baseName": "householdEstimatedSize",
            "type":     "string"
        },
        {
            "name":     "incomeEligibility",
            "baseName": "incomeEligibility",
            "type":     "string"
        },
        {
            "name":     "incomeLimit",
            "baseName": "incomeLimit",
            "type":     "string"
        },
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "number"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "string"
        },
        {
            "name":     "transactionMessage",
            "baseName": "transactionMessage",
            "type":     "string"
        },
        {
            "name":     "transactionStatus",
            "baseName": "transactionStatus",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningResponse.attributeTypeMap;
    }
}
